const getHome = (ajaxinstance) => {
  const customer = {}

  // 获取第二页内容--------------
  customer.question_index = (postData) => {
    return ajaxinstance.post('/index/question/index2', postData)
  }
  // 保存第二页信息--------------
  customer.saveTwo = (postData) => {
      return ajaxinstance.post('/index/question/saveTwo', postData)
  }

  return customer
}

export default getHome



// WEBPACK FOOTER //
// ./src/common/apis/articleDetails.js